import * as React from "react";
import { Card, CardContent, Box, Grid, Typography, CardActions, Tooltip } from "@mui/material";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import PersonIcon from "@mui/icons-material/Person";

import { config, styles } from "../../style";

import { format } from "date-fns";
import ClockIcon from "../../icons/ClockIcon";
import { formateDate } from "../../utils/date";
import GroupsIcon from "@mui/icons-material/Groups";
import PollIcon from "../../icons/PollIcon";
import ProposalIcon from "../../icons/ProposalIcon";
import LaunchIcon from "@mui/icons-material/Launch";

const EventCard = ({ event, type, displayProposalLink, onProposalLinkClick }) => {
    const formatTimeWithZone = (dateToFormat) => {
        if (dateToFormat) {
            // console.log('TIME ZONE')
            // console.log(dateToFormat)
            let num = new Date().getTimezoneOffset();

            if (num < 0) {
                num = Math.abs(num);
                const hours = String(Math.floor(num / 60)).padStart(2, "0");
                const minutes = String(Math.floor(num % 60)).padStart(2, "0");
                let timeZone = `${hours}:${minutes}`;
                return format(new Date(dateToFormat + "T05:00:00+" + timeZone), "MMMM d, yyyy");
            }
            const hours = String(Math.floor(num / 60)).padStart(2, "0");
            const minutes = String(Math.floor(num % 60)).padStart(2, "0");
            let timeZone = `${hours}:${minutes}`;
            // console.log(dateToFormat + 'T05:00:00-' + timeZone)
            return format(new Date(dateToFormat + "T05:00:00-" + timeZone), "MMMM d, yyyy");
        }
        return "";
    };
    return (
        <Card
            sx={{
                display: "flex",
                flexDirection: "column",
                cursor: "pointer",
                border: "1px solid #E9E9E9",
                minHeight: "200px",
                height: "100%",
            }}>
            <CardContent sx={{ p: 0, paddingBottom: "0px !important" }}>
                <Box
                    sx={{
                        p: "10px",
                        background: styles.card.cardHeaderColor,
                        display: "flex",
                        flexDirection: "row",
                        color: "#ffffff",
                        alignItems: "center",

                        ...(type === "proposal" && {
                            justifyContent: "space-between",
                        }),
                    }}>
                    {/* Left */}
                    {type === "proposal" && (
                        <Box sx={{ display: "flex", flexDirection: "row", color: "#ffffff", alignItems: "center" }}>
                            {/* <HistoryEduIcon fontSize="small" sx={{ mr: "10px" }}></HistoryEduIcon> */}
                            <ProposalIcon style={{ marginRight: "10px" }} /> Proposal
                        </Box>
                    )}
                    {type === "event" && (
                        <Box sx={{ display: "flex", flexDirection: "row", color: "#ffffff", alignItems: "center" }}>
                            <LocalActivityIcon fontSize="small" sx={{ mr: "10px" }}></LocalActivityIcon> Event
                        </Box>
                    )}

                    {/* Right */}

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            color: "#ffffff",
                            alignItems: "center",
                            justifyContent: "end",
                        }}>
                        {type === "proposal" && (
                            <>
                                {displayProposalLink && (
                                    <Box
                                        onClick={onProposalLinkClick}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            color: "#ffffff",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginRight: "10px",
                                        }}>
                                        <Tooltip title={"View Proposal"}>
                                            <LaunchIcon sx={{ width: "20px", height: "20px" }}></LaunchIcon>
                                        </Tooltip>
                                    </Box>
                                )}
                                {event.shared && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            color: "#ffffff",
                                            alignItems: "center",
                                        }}>
                                        <Tooltip title={event?.sharedText}>
                                            <GroupsIcon></GroupsIcon>
                                        </Tooltip>
                                    </Box>
                                )}
                                {!event.shared && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            color: "#ffffff",
                                            alignItems: "center",
                                            opacity: 0.5,
                                            "&:hover": {
                                                opacity: 1,
                                            },
                                        }}>
                                        <Tooltip title={"Not shared"}>
                                            <GroupsIcon></GroupsIcon>
                                        </Tooltip>
                                    </Box>
                                )}
                            </>
                        )}
                    </Box>
                </Box>
                <Box sx={{ p: "10px", display: "flex", flexDirection: "column" }}>
                    {type === "proposal" && (event.status || event.poll) && (
                        <Box display={"flex"} alignItems={"center"} marginBottom={"0.5rem"} marginTop={"0.25rem"}>
                            {event.status && (
                                <Typography
                                    component={"div"}
                                    borderRadius={event.status === "New" ? "16px" : "6px"}
                                    bgcolor={event.status === "New" ? "#FFF2E5" : "#F2F4F7"}
                                    color={event.status === "New" ? "#D0591D" : "#344054"}
                                    padding={"4px 8px"}
                                    fontSize={"12px"}
                                    fontWeight={500}
                                    lineHeight={"18px"}
                                    width={"fit-content"}
                                    marginRight={"1rem"}>
                                    {event.status}
                                </Typography>
                            )}
                            {event.poll && (
                                <Box
                                    component={"div"}
                                    color={"#24211E"}
                                    fontSize={"12px"}
                                    fontWeight={400}
                                    lineHeight={"20px"}
                                    display={"flex"}
                                    alignItems={"center"}>
                                    Poll:
                                    <Typography
                                        component={"div"}
                                        borderRadius="16px"
                                        bgcolor={event.poll === "Active" ? "#ECFDF3" : "#F2F4F7"}
                                        color={event.poll === "Active" ? "#027A48" : "#344054"}
                                        padding={"4px 8px"}
                                        fontSize={"12px"}
                                        fontWeight={500}
                                        lineHeight={"18px"}
                                        width={"fit-content"}
                                        display={"flex"}
                                        alignItems={"center"}
                                        marginLeft={"0.5rem"}>
                                        {/* <Box
                                            component={"div"}
                                            sx={{ width: "8px", height: "8px", borderRadius: "50%", background: event.poll === "Active" ? "#12B76A" : "#667085" }}
                                            marginRight={"0.5rem"}
                                        ></Box> */}
                                        <PollIcon
                                            style={{
                                                color: event.poll === "Active" ? "#12B76A" : "#667085",
                                            }}
                                        />
                                        {event.poll === "Active" ? "Active" : "Inactive"}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    )}
                    <h3
                        style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}
                        title={event.eventName}>
                        {event.eventName}
                    </h3>
                    <Grid
                        sx={{ my: "5px" }}
                        container
                        wrap="wrap"
                        spacing={0}
                        justifyContent="start"
                        direction="column">
                        <Grid item>
                            {event?.speakerName && (
                                <Box
                                    sx={{
                                        display: "inline-flex",
                                        verticalAlign: "text-bottom",
                                        boxSizing: "inherit",
                                        textAlign: "left",
                                        alignItems: "center",
                                        fontSize: "12px",
                                    }}>
                                    <PersonIcon fontSize="small" sx={{ color: "gray", width: "15px" }} />
                                    <span style={{ marginLeft: "5px" }}>{event?.speakerName}</span>
                                </Box>
                            )}
                        </Grid>
                        <Grid item>
                            {event?.startPlayDate ? (
                                <Box
                                    sx={{
                                        display: "inline-flex",
                                        verticalAlign: "text-bottom",
                                        boxSizing: "inherit",
                                        textAlign: "center",
                                        alignItems: "flex-start",
                                        mr: "20px",
                                        fontSize: "12px",
                                    }}>
                                    <CalendarMonthIcon fontSize="small" sx={{ color: "gray", width: "15px" }} />
                                    {/* <span style={{ marginLeft: "5px" }}>
                                        {format(new Date(event?.startPlayDate), "MMMM d, yyyy")}
                                    </span>
                                    {event?.endPlayDate && event?.startPlayDate !== event?.endPlayDate && (
                                        <span style={{ marginLeft: "5px" }}>
                                            {" "}
                                            - {format(new Date(event?.endPlayDate), "MMMM d, yyyy")}
                                        </span>
                                    )} */}
                                    <span style={{ marginLeft: "5px", textAlign: "start" }}>
                                        {formatTimeWithZone(event?.startPlayDate)}
                                        {event?.endPlayDate && event?.startPlayDate !== event?.endPlayDate && (
                                            <> - {formatTimeWithZone(event?.endPlayDate)}</>
                                        )}
                                    </span>
                                </Box>
                            ) : (
                                ""
                            )}
                        </Grid>
                        <Grid item>
                            {event?.venueName && (
                                <Box
                                    sx={{
                                        display: "inline-flex",
                                        verticalAlign: "text-bottom",
                                        boxSizing: "inherit",
                                        textAlign: "left",
                                        alignItems: "flex-start",
                                        fontSize: "12px",
                                    }}>
                                    <LocationOnIcon fontSize="small" sx={{ color: "gray", width: "15px" }} />
                                    <Typography variant="body" style={{ marginLeft: "5px" }}>
                                        {event?.venueName}
                                    </Typography>
                                </Box>
                            )}
                        </Grid>

                        <Grid item>
                            <Box
                                sx={{
                                    display: "inline-flex",
                                    verticalAlign: "text-bottom",
                                    boxSizing: "inherit",
                                    textAlign: "left",
                                    alignItems: "flex-start",
                                    fontSize: "12px",
                                }}>
                                <PersonIcon fontSize="small" sx={{ color: "gray", width: "15px" }} />
                                <Typography variant="body" sx={{ marginLeft: "5px" }}>
                                    {event.ownerName}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* <Badge sx={{ mt: 'auto' }} subject={formatStageName(event.stageName)}></Badge> */}
                </Box>
            </CardContent>

            {type === "proposal" && (
                <CardActions sx={{ borderTop: "1px solid #EAECF0" }}>
                    <Box display={"flex"} alignItems={"center"}>
                        <ClockIcon />
                        <Typography
                            component={"div"}
                            color={"#3A3F42"}
                            fontSize={"12px"}
                            lineHeight={"18px"}
                            fontWeight={400}
                            marginLeft={"0.25rem"}>
                            Last updated:
                            <Box component={"span"} fontWeight={500} marginLeft={"0.25rem"}>
                                {formateDate(event.lastUpdatedDate)}
                            </Box>
                        </Typography>
                    </Box>
                </CardActions>
            )}
            {/* <Grid sx={{ p: 0 }} container wrap="nowrap" spacing={2}>
                        <Grid item sx={{ background: '#dfdfdf', paddingTop: '15px', paddingLeft: '15px' }}>
                            
                        </Grid>
                        <Grid item xs zeroMinWidth sx={{ padding: '15px' }}>
                            <Box>
                                <Typography noWrap>{record?.eventName}</Typography>
                            </Box>
                            <Box>
                                <span style={{ fontSize: '12px' }}>{record?.stageName}</span>
                            </Box>
                        </Grid>
                    </Grid> */}
        </Card>
    );
};

const formatStageName = (name) => {
    if (name === "Proposal") {
        return "Open";
    }
    return "Planned";
};

export { EventCard };
